import { useState } from "react";
import { Picker } from "@design-system/Picker/Picker.lib";
import { PlusIcon } from "@icons";
import { resolveTrigger } from "./PickerPlaygroundOptionControls";
import { useStageData, type StageProps } from "./PickerPlaygroundStage.lib";

/** `allowCustomValue` stage: suggestions (flat, tree or sectioned) plus a `Use "query"` footer. */
export const CustomValueStage = ({
    features,
    forcedState,
    onValueChange,
    onFooterSelect,
}: StageProps) => {
    const [text, setText] = useState("");
    const { items, sections, flyoutDefaults } = useStageData(
        features,
        onFooterSelect,
    );
    const trigger = resolveTrigger(features);

    return (
        <Picker.Select
            items={items}
            sections={sections}
            nested={features.nested}
            selectableParents={
                features.isTree ? features.hasSelectableParents : undefined
            }
            flyoutDefaults={flyoutDefaults}
            flyoutQueryScope={features.flyoutQueryScope}
            flyoutAutoOpen={features.flyoutAutoOpen}
            chevron={features.chevron}
            value={text}
            placeholder="Describe the expense"
            disabled={features.isDisabled}
            status={features.status}
            trigger={trigger === "cellInput" ? "cellInput" : "input"}
            allowCustomValue
            filterable={features.isFilterable}
            emptyBehavior={features.emptyBehavior}
            clearable={features.isClearable}
            data-forced-state={forcedState}
            onValueChange={(next) => {
                setText(next);
                onValueChange(next);
            }}
            renderFooter={
                features.hasFooter
                    ? (query) =>
                          query.trim() === "" ? null : (
                              <Picker.Item
                                  leading={<PlusIcon />}
                                  onSelect={() => {
                                      setText(query);
                                      onFooterSelect(query);
                                  }}
                              >
                                  {`Use "${query.trim()}"`}
                              </Picker.Item>
                          )
                    : undefined
            }
        />
    );
};
